export default "__VITE_ASSET__CvC52t75__"